module.exports = __webpack_public_path__ + "static/menu-wakaba-min-136c17f44f5c16329fce995c9c39efa4.jpg";